module.exports = __webpack_public_path__ + "img/courier-wardtrucking.06bb4401.svg";